/**
 * @Author wuTao
 * @description 评语新增编辑页面
 * @Date 2020/08/18
 */
import React from 'react';
import {connect} from 'dva';
import {component_tool, framework_tool, utils_tool} from '@/tool';
import {WizAuthority} from '@/containers/common';
import TrainPathCommentDetailList from '../commentDetail/commentDetailList';
import { formatAuth } from '@/utils/commonUtils'

let {WizContainer, modelUtils} = framework_tool;
let {WizCard, WizForm, WizSpin, WizTooltip} = component_tool;
let {Session, $$, checkStrLength} = utils_tool;

class TrainPathCommentDetail extends WizContainer {

  componentName = 'TrainPathCommentDetail';

  constructor(props) {
    super(props);
    const {history} = props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/comment/trainPathCommentUpd') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('trainPathCommentUpd', initialValue)
      } else {
        initialValue = Session.get('trainPathCommentUpd') || {};
      }
    }
    this.state = {
      detailedVisible: false,
    };
    this.initialValue = initialValue;
    this.initialValue.detailedList = [];
    this.initialValue.maxSort = null;
    this.clearWizCallBack = [];
  }

  _componentDidMount() {
    const {history} = this.props;
    if (this.initialValue && this.initialValue.id) {
      //需初始化数据
      this.getTrainPathCommentDetailedByTrainPathCommentId()
    }
  }

  propsAndStateOnChange = {
    addTrainPathComment: this._addTrainPathCommentOver.bind(this),
    updateTrainPathComment: this._updateTrainPathCommentOver.bind(this),
    trainPathCommentDetailedList: this._getTrainPathCommentDetailedListOver.bind(this),
  };

  /**编辑时获取对应的评语考核内容明细数据 */
  getTrainPathCommentDetailedByTrainPathCommentId() {
    this.doAction({
      path: 'trainPathCommentDetailedManagement/list',
      payload: {
        key: 'trainPathCommentDetailedList',
        apiParams: {
          trainPathCommentId: this.initialValue.id,
        }
      }
    });
  }

  /**
   * 将查询到的评语考核内容明细数据
   */
  _getTrainPathCommentDetailedListOver(nextProps, nextState) {
    let trainPathCommentDetailedList = nextProps.trainPathCommentDetailedList.data;
    if (nextProps.trainPathCommentDetailedList.code == 1 && trainPathCommentDetailedList && trainPathCommentDetailedList.length) {
      let maxSort = 0;
      //重新排序
      trainPathCommentDetailedList.sort(function (a, b) {
        if (a['sort'] < b['sort']) {
          return -1
        }
        if (a['sort'] > b['sort']) {
          return 1
        }
        return 0;
      });

      let neoValue = Object.assign([]);
      if (trainPathCommentDetailedList) {
        trainPathCommentDetailedList.forEach(data => {
          const {id, sort} = data;
          if (sort && sort > maxSort) {
            maxSort = sort;
          }
          data.key = new Date().getTime() + sort + '_commentDetail';
          neoValue.push(data);
        })
      }
      this.initialValue.detailedList = neoValue;
      this.initialValue.maxSort = maxSort;
    }
    return true;
  }

  /**
   * 评语新增成功返回原页面，失败弹出提示
   */
  _addTrainPathCommentOver(nextProps, nextState) {
    if (nextProps.addTrainPathComment.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/comment');
    } else {
      wizNotice.error('提交失败：' + nextProps.addTrainPathComment.msg);
    }
    return true;
  }

  /**
   * 评语修改成功返回原页面，失败弹出提示
   */
  _updateTrainPathCommentOver(nextProps, nextState) {
    if (nextProps.updateTrainPathComment.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/comment');
    } else {
      wizNotice.error('提交失败：' + nextProps.updateTrainPathComment.msg);
    }
    return true;
  }

  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if ((key === 'updateTime' || key === 'createTime') && value != null && value != undefined) {
        fitterValues[key] = value.format("YYYY-MM-DD HH:mm:ss");
      } else if (key === 'detailedList' && value != null && value != undefined) {
        let newValue = Object.assign([]);
        /**
         * 列表数据处理
         */
        value.forEach(detail => {
          const {id} = detail;
          if (!id || id === undefined) {
            detail.id = null;
          }
          newValue.push(detail)
        })
        fitterValues[key] = newValue;
      } else if (key === 'manageTargetScope') {
        /**
         * 权限参数处理
         */
        // let manageTargetScope = {}
        // if (value != null && value != undefined) {
        //   manageTargetScope.orgIds = value.orgIds && value.orgIds.map(p => (p.id))
        //   manageTargetScope.positionIds = value.positionIds && value.positionIds.map(p => (p.id))
        //   manageTargetScope.positionCategoryIds = value.positionCategoryIds && value.positionCategoryIds.map(p => (p.id))
        //   manageTargetScope.personIds = value.personIds && value.personIds.map(p => (p['id']))
        // } else {
        //   manageTargetScope.orgIds = [];
        //   manageTargetScope.positionIds = [];
        //   manageTargetScope.positionCategoryIds = [];
        //   manageTargetScope.personIds = [];
        // }
        // manageTargetScope.isAll = value.isAll
        // fitterValues[key] = manageTargetScope;

        fitterValues[key] = formatAuth(value)
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    return fitterValues;
  }

  /**
   * 保存/更新 评语信息
   * @param values
   * @private
   */
  _saveTrainPathComment(values) {
    const {history} = this.props;
    let apiPath = "trainPathCommentManagement/add";
    let payloadKey = "addTrainPathComment";
    if (history.location && history.location.pathname === '/comment/trainPathCommentUpd') {
      apiPath = "trainPathCommentManagement/update";
      payloadKey = "updateTrainPathComment";
    }
    let fitterValues = this.fitterFieldsValue(values);
    this.doAction({
      path: apiPath,
      payload: {
        key: payloadKey,
        apiParams: {
          ...fitterValues
        }
      }
    });
  }

  commentColumns = (initialValue) => {
    return [
      {
        formItem: {
          type: "hidden",
          initialValue: initialValue && initialValue.id
        },
        name: "id"
      },
      {
        formItem: {
          type: "hidden",
          initialValue: initialValue && initialValue.state
        },
        name: "state"
      },
      {
        title: "名称",
        name: "name",
        dataIndex: "name",
        formItem: {
          maxlength: 30,
          placeholder: '名称最多输入30个字',
          rules: [{
            required: true,
            message: '请输入评语名称',
          }
          ],
          initialValue: initialValue && initialValue.name
        },
      },
      {
        title: "管理范围",
        name: "manageTargetScope",
        formItem: {
          type: 'diy',
          diy: WizAuthority,
          showBlock: false,
          mode: 'Form',
          initialValue: initialValue && initialValue.manageTargetScope,
          record: {
            manageTargetScope: initialValue && initialValue.manageTargetScope
          },
          keys: ['orgIds', 'positionIds', 'positionCategoryIds', 'personIds'],
          rules: [{
            required: true,
            message: '请输入管理范围',
          }]
        },
        onClearWiz: this._onClearWiz.bind(this)
      },
      {
        title: "介绍",
        name: "briefIntroduction",
        dataIndex: "briefIntroduction",
        formItem: {
          type: 'textarea',
          rows: 4,
          placeholder: '请输入最多介绍255个字',
          maxlength: 255,
          rules: [],
          initialValue: initialValue && initialValue.briefIntroduction,
        }
      },
      {
        title: "考核内容",
        name: "detailedList",
        formItem: {
          type: 'diy',
          diy: TrainPathCommentDetailList,
          maxSort: this.initialValue.maxSort && this.initialValue.maxSort,
          trainPathCommentId: initialValue && initialValue.id,
          initialValue: initialValue && initialValue.detailedList,
          rules: [{
            required: true,
            message: '请添加考核内容',
          }]
        }
      }
    ]
  }

  _render() {
    const {trainPathCommentManagementLoading, trainPathCommentDetailedManagementLoading} = this.props;
    let initialValue = this.initialValue;
    let cardTitle = '新增';
    if (initialValue && initialValue.id) {
      cardTitle = '编辑';
    }
    let columns = this.commentColumns(initialValue);
    let onSubmit = this._saveTrainPathComment.bind(this);

    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 18}
      },
      style: {maxWidth: '100%', width: '100%'}
    }

    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={trainPathCommentManagementLoading || trainPathCommentDetailedManagementLoading}>
          <WizForm key='commentForm' className={'form-inline'} {...formProps} />
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {trainPathCommentManagement, trainPathCommentDetailedManagement} = state;
  const addTrainPathComment = modelUtils.getModelEntity(trainPathCommentManagement, "addTrainPathComment");
  const updateTrainPathComment = modelUtils.getModelEntity(trainPathCommentManagement, "updateTrainPathComment");
  const trainPathCommentDetailedList = modelUtils.getModelEntity(trainPathCommentDetailedManagement, "trainPathCommentDetailedList");
  const load = modelUtils.getLoadingState(state, ['trainPathCommentManagement', 'trainPathCommentDetailedManagement']);
  return {
    addTrainPathComment: addTrainPathComment,
    updateTrainPathComment: updateTrainPathComment,
    trainPathCommentDetailedList: trainPathCommentDetailedList,
    ...load
  }
};

export default connect(mapStateToProps)(TrainPathCommentDetail);
